import Layout from '@/app/Layout';

import IconHeart from '@/assets/icons/heart.svg?react';

export default function EndCallPage() {
  return (
    <Layout>
      <div className="flex flex-1 flex-col items-center justify-center">
        <IconHeart className="mb-6 h-20 w-20 fill-blue-1" />
        <h1 className="text-center text-3xl text-gray-900 dark:text-white">
          Thank you for the call!
        </h1>
      </div>
    </Layout>
  );
}
